import React from "react";
import Handpumps from "../assets/Negro.png";
import water from "../assets/water.jpg";
import "../App.css";

export default function OffsetProject() {
  return (
    <section className="container my-5">
      {/* Title */}
      <div className="text-center mb-4">
        <h2
          className="fw-bold"
          style={{
            color: "#063970",
            fontWeight: "bold",
            fontFamily: "Oswald, sans-serif",
          }}
        >
          Offset Project
        </h2>
        <p>
          Our selected projects are Gold Standard or VCS-certified, ensuring
          that your contributions make a real, measurable impact on the planet.
          These initiatives go beyond simply reducing carbon emissions—they
          actively support sustainable development, biodiversity conservation,
          and climate resilience. By choosing these projects,
        </p>
      </div>

      {/* Project Cards */}
      <div className="row justify-content-center g-4">
        <div className="col-md-5">
          <div className="card border-0 shadow-sm h-100">
            <img
              src={Handpumps}
              className="card-img-top rounded"
              alt="Rio Negro Amazon Project"
            />
            <div className="card-img-overlay d-flex align-items-end p-3">
              <h5
                className="text-white fw-bold"
                style={{
                  fontFamily: "Oswald, sans-serif",
                }}
              >
                Rio Negro Amazon Project
              </h5>
            </div>
          </div>
        </div>

        <div className="col-md-5">
          <div className="card border-0 shadow-sm h-100">
            <img
              src={water}
              className="card-img-top rounded"
              alt="Vietnam Improved Cookstove"
            />
            <div className="card-img-overlay d-flex align-items-end p-3">
              <h5
                className="text-white fw-bold"
                style={{
                  fontFamily: "Oswald, sans-serif",
                }}
              >
                Vietnam Improved Cookstove
              </h5>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
